import React from 'react';
import { getOptions } from '../aggregationUtil';
import { newInteractiveFilter } from './interactiveFilter';

const Filter = newInteractiveFilter('work_id', getOptions);

export const WorkInteractiveFilter = ({
  musicalWorks,
  aggregationQuery,
  onSelectValue,
  onClearValue,
  label,
  ...additionalProps
}) => (
  <Filter
    options={musicalWorks}
    aggregationQuery={aggregationQuery}
    onSelectValue={onSelectValue}
    onClearValue={onClearValue}
    label={label}
    {...additionalProps}
  />
);
